import { Data as _Data } from './modules/Data';
import _addClass from './functions/addClass';
import _hasClass from './functions/hasClass';
import _hasValue from './functions/hasValue';
import _getAjax from './functions/getAjax';
import _postAjax from './functions/postAjax';
import _serialize from './functions/serialize';
import _serializeArray from './functions/serializeArray';
global.HTMLElement = global.HTMLElement || function () { };
HTMLElement.prototype.data = function (key, value) {
    var Data = new _Data(this);
    if ((key !== null && typeof key !== "undefined") && (value !== null && typeof value !== "undefined")) {
        Data.setDataValue(key, value);
        return this;
    }
    if (key !== null && typeof key !== "undefined") {
        return Data.getDataValue(key);
    }
    return Data.data;
};
global.HTMLDivElement = global.HTMLElement || function () { };
HTMLDivElement.prototype.data = HTMLElement.prototype.data;
export default {
    Data: _Data,
    addClass: _addClass,
    hasClass: _hasClass,
    hasValue: _hasValue,
    getAjax: _getAjax,
    postAjax: _postAjax,
    serialize: _serialize,
    serializeArray: _serializeArray
};
//# sourceMappingURL=library.js.map